<script>
import Card from "@/components/molecules/card";
import ButtonIcon from "@/components/molecules/button-icon";
import Button from "@/components/atoms/button";
import Titre from "@/components/atoms/titre";
import Divider from "@/components/atoms/divider";
import Icon from "@/components/atoms/icon";

export default {
  name: "AbonnementLadVignette",
  components: {
    Card,
    ButtonIcon,
    Titre,
    Divider,
    Button,
    Icon
  },
  props: {
    abonnement: {
      type: Object,
      required: true,
      default: () => {}
    },
    prix: {
      type: String,
      required: true
    },
    prixBarre: {
      type: String,
      required: false,
      default: null
    },
    hasAboInCart: {
      type: Boolean,
      required: false,
      default: false
    },
    quantity: {
      type: Number,
      required: false,
      default: 0
    },
    displayMode: {
      type: String,
      required: false
    }
  },
  emits: ["removeItem", "addToCart"]
};
</script>
<template>
  <Card
    :class="quantity > 0 && 'c-abonnement-lad-vignette-card-in-cart'"
    radius="lg"
    border-size="1"
    border-color="border"
    class="c-abonnement-lad-vignette-card u-box-shadow-md u-py-lg u-px-md u-p-md@md u-text-center"
  >
    <div
      v-if="quantity > 0"
      class="c-abonnement-lad-vignette-card-check"
    >
      <Icon
        name="check"
        size="md"
        variant="white"
      />
    </div>
    <div class="c-abonnement-lad-vignette-card__content">
      <Titre
        tag="h1"
        variant="black"
        size="lg"
        class="u-mb-md"
      >
        {{ abonnement.duree }} {{ abonnement.unite }}
      </Titre>

      <Divider
        size="sm"
        dotted
        class="u-full-width"
      />
      <div
        v-if="prixBarre"
        class="c-abonnement-lad-vignette-prix-barre"
      >
        <p>{{ formatPrix(prix) }} €</p>
        <p class="u-font-14">
          au lieu de <span style="text-decoration: line-through;">{{ formatPrix(prixBarre) }}</span> €
        </p>
      </div>
      <p
        v-else
        class="u-color-secondary u-font-30 u-font-700 u-my-md u-my-sm@md"
      >
        {{ formatPrix(prix) }} €
      </p>
      <p
        v-if="parseInt(abonnement.duree, 10) === 1"
        class="u-font-700"
      >
        rentabilisé dès la deuxième commande
      </p>
      <p
        v-else
        class="u-font-14 u-mb-xxs"
      >
        soit
        <span
          v-if="abonnement.prix_unitaire_abonnement < abonnement.prix_unitaire_abonnement_reference "
          class="u-color-grey-2"
          style="text-decoration: line-through;"
        > {{ formatPrix(abonnement.prix_unitaire_abonnement_reference) }} €</span> {{ formatPrix(abonnement.prix_unitaire_abonnement) }} € / mois
      </p>
      <p v-if="abonnement.discount_percent_abonnement_reference && abonnement.prix_unitaire_abonnement !== abonnement.prix_unitaire_abonnement_reference">
        {{ formatPrix(abonnement.discount_percent_abonnement_reference) }} % d'économie
      </p>
      <template v-if="displayMode !== 'appli'">
        <div
          v-if="quantity > 0"
          class="c-abonnement-lad-vignette-button-line"
        >
          <div class="u-full-width u-flex u-flex-justify-between u-mt-lg u-mt-sm@md">
            <Button
              link
              @click="$emit('removeItem')"
            >
              <span class="u-font-12">
                Supprimer
              </span>
            </Button>
            <div class="c-abonnement-lad-vignette-in-cart">
              Dans votre panier
            </div>
          </div>
        </div>
        <div
          v-else-if="hasAboInCart"
          class="c-abonnement-lad-vignette-button-line"
        >
          <Button
            variant="secondary"
            size="md"
            radius="full"
            icon-color-hover="white"
            class="u-mt-lg u-mt-sm@md"
            @click="$emit('addToCart')"
          >
            Choisir cette formule
          </Button>
        </div>
        <div
          v-else
          class="c-abonnement-lad-vignette-button-line"
        >
          <ButtonIcon
            variant="secondary"
            size="md"
            radius="full"
            icon-name="cart"
            icon-size="sm"
            icon-color="white"
            icon-color-hover="white"
            class="u-mt-lg u-mt-sm@md"
            @click="$emit('addToCart')"
          >
            Ajouter au panier
          </ButtonIcon>
        </div>
      </template>
    </div>
  </Card>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/abonnement-lad-vignette.scss";
</style>
